import { render } from "./EntriesResume.vue?vue&type=template&id=3af98f7a"
import script from "./EntriesResume.vue?vue&type=script&lang=js"
export * from "./EntriesResume.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__